import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SavingsSection() {
  return <section className="py-20 md:py-32 bg-cream relative border-t border-sand/50" data-id="element-257">
      <div className="max-w-4xl mx-auto px-4" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-259">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal leading-tight" data-id="element-260">
            ¿Cuánto te cuesta seguir igual?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-261">
          {/* Delivery Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-sand rounded-2xl p-8 shadow-sm flex flex-col items-center text-center" data-id="element-262">
            <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-6" data-id="element-263">
              <X size={24} className="text-red-500" data-id="element-264" />
            </div>
            <h3 className="text-sm font-bold tracking-widest text-charcoal/50 uppercase mb-2" data-id="element-265">
              DELIVERY
            </h3>
            <p className="text-lg text-charcoal/80 font-medium mb-6" data-id="element-266">
              3 veces por semana
            </p>
            <div className="mt-auto" data-id="element-267">
              <span className="text-4xl md:text-5xl font-serif font-bold text-charcoal" data-id="element-268">
                ≈ $180.000
              </span>
              <span className="block text-sm font-bold text-charcoal/40 uppercase tracking-widest mt-2" data-id="element-269">
                por mes
              </span>
            </div>
          </motion.div>

          {/* AirPack Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-ember rounded-2xl p-8 shadow-xl flex flex-col items-center text-center relative overflow-hidden" data-id="element-270">
            <div className="absolute top-0 left-0 w-full h-1 bg-ember" data-id="element-271" />
            <div className="w-12 h-12 rounded-full bg-green-50 flex items-center justify-center mb-6" data-id="element-272">
              <Check size={24} className="text-green-600 stroke-[3]" data-id="element-273" />
            </div>
            <h3 className="text-sm font-bold tracking-widest text-ember uppercase mb-2" data-id="element-274">
              AIRPACK
            </h3>
            <p className="text-lg text-charcoal/80 font-medium mb-6" data-id="element-275">
              Pago único
            </p>
            <div className="mt-auto" data-id="element-276">
              <span className="text-2xl md:text-3xl font-serif font-bold text-ember" data-id="element-277">
                ≈ menos que una semana de delivery
              </span>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-278">
          <p className="text-xl md:text-2xl font-serif italic text-charcoal/70" data-id="element-279">
            Una sola semana de delivery puede costar más que todo el sistema.
          </p>
        </motion.div>
      </div>
    </section>;
}